import React from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const IconPercent = React.forwardRef<SVGSVGElement, any>((props, ref) => {
  return (<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon-percent" data-icon="icon-percent" aria-hidden="true" {...props} ref={ref}><line x1="19" y1="5" x2="5" y2="19"/><circle cx="6.5" cy="6.5" r="2.5"/><circle cx="17.5" cy="17.5" r="2.5"/></svg>);
});

IconPercent.displayName = 'IconPercent';
